/* Shto cart: adds to the cart exactly the way the live product pages' buy box does (the custom script on
   /products/pure-magnesium-glycinate: POST /cart/add.js with JSON, then refreshCartDrawer()), so the store's cart drawer
   opens as on the live site and the store's own add to cart tracking sees the same request.

   window.ShtoCart.add([{ id: variantId, quantity: 1, selling_plan: planId }]) -> Promise of Shopify's /cart/add.js answer.
   Leave selling_plan out for a one-time purchase. Several items go in one request (the "take it with" buttons).
   It rejects with Shopify's message (e.g. sold out) so the caller can show it. */
(function () {
  if (window.ShtoCart) return;

  // Copied from the live page's refreshCartDrawer: UpCart if present, else the header cart icon, else Dawn's drawer.
  function openCart(attempt) {
    attempt = attempt || 0;
    if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return; }
    var trigger = document.getElementById('cart-icon-bubble');
    if (trigger) { trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true })); return; }
    if (attempt < 5) { setTimeout(function () { openCart(attempt + 1); }, 200); return; }
    var drawer = document.querySelector('.drawer');
    if (!drawer) return;
    drawer.classList.remove('is-empty');
    drawer.classList.add('active');
    fetch('/cart?view=drawer').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fragment = doc.querySelector('#CartDrawer');
      drawer.innerHTML = fragment ? fragment.outerHTML : '';
      document.body.classList.add('cart-open');
    });
  }

  window.ShtoCart = {
    open: openCart,
    add: function (items) {
      var body = items.length === 1 ? items[0] : { items: items };
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart');
          return d;
        });
      }).then(function (added) { openCart(); return added; });
    }
  };
})();
